import { Pasajero }    from '../obj/pasajero';
export class Compra {

    public id: string;
    public idPoliza: string;
    public ciudadEntrega: string;
    public jornadaEntrega: string;
    public fechaEntrega: string;
    public direccionEntrega: string;
    public usuario: string;
    public referencia: string;
    public idReferencia: string;
    public intermediario: string;
    public medioPago: string;
    public tipo: string;
    public cupon: string;
    public cvTelefonoMovil: string;
    public cvDireccion: string; 
    public ceNombre: string;
    public ceApellido: string;
    public ceTelefono: string;
    public ceEmail: string;
    public facDocumento: string;
    public facNombre: string;
    public facDireccion: string;   
    public facTelefono: string;   
    public facCiudad: string;    
    public pasajeros: Pasajero[] = [];

    public titularLealCoin: string;
    public emailLealCoin: string;
    public puntosActivosLealCoin: string;   
    public uidLealCoin: string;   


    constructor()    {}
}



// WEBPACK FOOTER //
// ./src/app/obj/compra.ts